// extracted by mini-css-extract-plugin
module.exports = {"dialogue":"styles_dialogue__1QAka","question":"styles_question__27IyJ","forDots":"styles_forDots__25GOJ","spin":"styles_spin__1eUh2"};